import React, { useState } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../assets/css/login-register.css'; 

export default function Register() {
    const navigate = useNavigate();
    const [fname, setFastName] = useState('');
    const [lname, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleFirstNameChange = (e) => {
        setFastName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/register`, { 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ fname, lname, email, password }),
            });
    
            const data = await response.json();

            //Check if user register or not
            if(data.status === true){
                toast.success('Account Register Successfully.');
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error('Opps Something Wrong. Please Try Again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="login-saction">
                <div className="container">
                    <div className="left-side-login">
                        <div className="logo">
                            <Link to="/register">
                                <img src={`${process.env.PUBLIC_URL}/images/Logo-login.svg`} alt="logo.svg" />
                            </Link>
                        </div>
                        <h2>Sign Up</h2>
                        <span>Welcome back! Please enter your details</span>
                        <div className="from-login">
                            <form onSubmit={handleLogin}>
                                <div className="row-input">
                                    <input type="text" value={fname} onChange={handleFirstNameChange} placeholder="First Name" required />
                                </div>
                                <div className="row-input">
                                    <input type="text" value={lname} onChange={handleLastNameChange}  placeholder="Last Name" required />
                                </div>
                                <div className="row-input">
                                    <input type="email" value={email} onChange={handleEmailChange}  placeholder="Email Address" required />
                                </div>
                                <div className="row-input">
                                    <input type="password" value={password} onChange={handlePasswordChange} placeholder="Password" required />
                                </div>
                                <button type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </form>
                            <p className="create-account">
                            Already have an account? <Link to="/">Login</Link>
                            </p>
                        </div>
                    </div>
                    <div className="right-side-login">
                        <img src={`${process.env.PUBLIC_URL}/images/business-concept.png`} alt="business-concept.png" />
                    </div>
                </div>
            </div>
        </>
    );
}
